import React, { useEffect } from "react";
import xmarkIcon from "../assets/xmark.svg";

export function GatewayModal({
  open = true,
  title,
  subtitle = "",
  children,
  footer = null,
  onClose,
  className = "",
  bodyClassName = "",
  width,
  zIndex = 110,
  ariaLabel,
  ...dialogProps
}) {
  useEffect(() => {
    if (!open || !onClose) return undefined;
    const closeOnEscape = (event) => {
      if (event.key !== "Escape" || event.defaultPrevented) return;
      // The AI Assistant drawer floats above every modal and owns its own
      // Escape (it closes the drawer). Letting it through here would close
      // the modal underneath — and drop whatever was being edited in it.
      const target = event.target;
      if (target && typeof target.closest === "function" && target.closest(".gwAIPopover")) return;
      onClose();
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [onClose, open]);

  if (!open) return null;
  return (
    <div
      className="gwOverlay"
      style={{ zIndex }}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose?.();
      }}
    >
      <div
        className={`gwModal${className ? ` ${className}` : ""}`}
        style={width ? { width } : undefined}
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel || title}
        {...dialogProps}
      >
        <div className="gwModalHeader">
          <div>
            <div className="gwModalTitle">{title}</div>
            {subtitle ? <div className="gwModalSubtitle">{subtitle}</div> : null}
          </div>
          {onClose ? (
            <button className="gwModalClose" type="button" onClick={onClose} aria-label="Close">
              <img src={xmarkIcon} alt="" className="gwIcon" width="10" height="10" />
            </button>
          ) : null}
        </div>
        <div className={`gwModalBody${bodyClassName ? ` ${bodyClassName}` : ""}`}>{children}</div>
        {footer ? <div className="gwModalFooter">{footer}</div> : null}
      </div>
    </div>
  );
}

export function GatewayConfirmDialog({
  title,
  body,
  confirmLabel,
  danger = false,
  busy = false,
  onCancel,
  onConfirm,
  width = 440,
  zIndex = 110,
}) {
  return (
    <GatewayModal
      title={title}
      onClose={onCancel}
      width={width}
      zIndex={zIndex}
      bodyClassName="gwConfirmDialogBody"
      footer={(
        <>
          <button className="gwGhostBtn" type="button" onClick={onCancel}>Cancel</button>
          <button
            className={danger ? "gwDangerBtn" : "gwPrimaryBtn"}
            type="button"
            disabled={busy}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </>
      )}
    >
      <p className="gwConfirmDialogText">{body}</p>
    </GatewayModal>
  );
}

export default GatewayModal;
